export default __webpack_public_path__ + "static/media/trafic-large.1b1dd131.jpg";